var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGenderMale = function SvgGenderMale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4753 16.9496V22.6575C29.4753 24.9137 28.5336 27.0676 26.8772 28.5997L22.3811 32.7586C21.8825 33.2198 21.2282 33.476 20.549 33.476H14.7924C14.1131 33.476 13.4588 33.2198 12.9602 32.7585L8.46418 28.5997C6.80789 27.0676 5.86621 24.9137 5.86621 22.6575V17.2447",
    stroke: "#FF8C69",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5242 6.12862L28.4917 4.16138C28.4917 4.16138 23.755 2.05592 18.6547 2.19397C13.5544 2.33202 10.7848 5.14511 10.7848 5.14511C10.7848 5.14511 6.73816 3.17768 5.86642 9.07996C4.97133 13.2802 5.86653 18.9171 5.86653 18.9171C5.86653 18.9171 8.08739 16.9772 9.0144 15.3758C10.0984 13.5033 11.7687 11.0474 11.7687 11.0474C11.7687 11.0474 14.8635 12.7371 17.6708 13.0146C20.2124 13.2658 21.0562 11.4004 23.573 11.8344C27.22 12.4633 29.4758 18.9171 29.4758 18.9171L29.4756 11.8344C29.4756 9.00132 27.5735 6.71884 26.5242 6.12862Z",
    stroke: "#FF8C69",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGenderMale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gender_male.72a5d0c1.svg";
export { ForwardRef as ReactComponent };